
export function isWindowsDataset(dataset) {

  if (dataset) {
    return dataset.createdByClientId === 'quicken_windows';
  }
  return true;  // default to windows behavior
}
